import styled from '@emotion/styled';
import { space, SpaceProps } from 'styled-system';

export type HeroFooterProps = SpaceProps;

export const HeroFooter = styled.div<HeroFooterProps>(
  {
    marginBottom: '0',
  },
  space
);
